import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

const MiniSecondaryOption = ({
  cost,
  description,
  optionCode,
  optionName,
  url,
}) => (
  <div className={styles.secondaryOption}>
    <span>
      <img className={styles.image} alt={optionCode} src={url} />
    </span>
    <span>
      {optionName}: {optionCode} - {description} (${cost})
    </span>
  </div>
);

export default enhance(MiniSecondaryOption);
